import { h } from "snabbdom";
// import { Boot} from '@wangeditor/editor'
import { nanoid } from "nanoid";
import { DomEditor } from "@wangeditor/core";
// 渲染函数
function fn(elem, children, editor) {
  // elem 即当前节点
  // children 是下级节点
  // editor 即编辑器实例
  // console.log(elem);
  var { a, b, c, mpImId, id } = elem;
  // let str = genID(8);
  // console.log();
  function imgErr() {
    console.log();
    let arr = document.getElementById(id);
    console.log(arr);
    arr.setAttribute("src", require("@/assets/zwx.png"));
    c = "require('@/assets/zwx.png')";
  }
  const selected = DomEditor.isNodeSelected(editor, elem);
  const vnode = h(`div#container.two.classes.${selected ? "selected" : ""}`, [
    h("div.message", {}, [
      h("div.top", {}, [
        h("div.title", {}, a),
        h("div.content", {}, b),
        c
          ? h(
              `img#${id}`, //#${str}
              {
                src: c,
                alt: "",
                on: { error: imgErr },
              },
              []
            )
          : h("span", {}, []),
      ]),
      h("div.bottom", {}, [
        h("div", {}, "查看详情"),
        h("i.el-icon-arrow-right", {}, []),
      ]),
    ]),
  ]);
  return vnode;
}

// 渲染配置
const conf = {
  type: "message", // 节点 type ，重要！！！
  renderElem: fn,
};
export default conf;
